//工具类
import { getUrlParam } from './util';
/**
 * 获取小程序标识，有就代表是小程序
 * 货拉拉小程序，有_token和version参数
 * @returns {boolean}
 */
function isWxMiniProgram() {
  //我们客户端小程序特有的判断方式,小程序链接上带参数进行判断
  //若无该参数,则尝试使用原生判断
  if (getUrlParam('ua') == 'wxa') return true;
  if (getUrlParam('ua') == 'bjwxa') return true;
  if (getUrlParam('ua') == 'ltlwxa') return true;
  if (getUrlParam('client_type') == 'xl_wxa') return true;
  //判断是否是小程序
  let u = navigator.userAgent;
  return /MicroMessenger/gi.test(u) && /miniProgram/gi.test(u);
}
/**
 * 是否物流app
 */
function isLtlApp() {
  return isHllApp() && getUrlParam('ua') == 'isltlApp';
}
/**
 * 是否京东小程序
 */
function isJdMiniProgram() {
  return getUrlParam('ua') == 'bjjd';
}
/**
 * 是否搬家小程序
 */
function isMoveMini() {
  return getUrlParam('ua') == 'bjwxa';
}

/**
 * 是否小拉小程序
 */
function isXlMini() {
  return getUrlParam('client_type') == 'xl_wxa';
}

/**
 * 是否搬家支付宝小程序
 */
function isMoveAlpayMini() {
  return getUrlParam('ua') == 'bjali';
}
/**
 * 是否物流小程序
 */
function isLtlMiniProgram() {
  return getUrlParam('ua') == 'ltlwxa';
}
/**
 * 是否是小拉小程序
 * @returns boolean
 */
function isXiaoLaProgram() {
  return getUrlParam('client_type') == 'xl_wxa';
}
/**
 * 是否xl小程序
 * @returns Boolean
 */
function isXlMiniProgram() {
  return getUrlParam('client_type') == 'xl_wxa';
}

/**
 * 是否xl app
 * @returns Boolean
 */
function isXlAppByClientType() {
  return ['xl_ios', 'xl_android'].includes(getUrlParam('client_type'));
}

/**
 * isWxMiniProgram方法不能覆盖到微信7.0以下版本
 * 更新: isWxMiniProgram可以正常判断所有货拉拉微信小程序(所有链接已携带ua=wxa参数)
 */
function isWxMiniProgramNew() {
  let u = navigator.userAgent;
  return new Promise(function(resolve, reject) {
    if (/MicroMessenger/i.test(u)) {
      if (/miniProgram/i.test(u)) {
        // 微信小程序
        resolve(true);
      } else if (wx && wx.miniProgram) {
        wx.miniProgram.getEnv(function(res) {
          if (res.miniprogram) {
            return resolve(true);
          } else {
            reject(false);
          }
        });
        return;
      } else {
        reject(false);
      }
    } else {
      reject(false);
    }
  });
}

//是否是支付宝小程序
function isAlipayMiniUa() {
  return getUrlParam('ua') == 'alipay' || getUrlParam('ua') == 'bjali';
}
//是否是快应用
function isQuickAppUa() {
  return getUrlParam('ua') == 'quick_app';
}
//是否搬家m站
function isBanjiaH5() {
  return getUrlParam('ua') == 'bjh5';
}
//是否百度小程序
function isBaiduBoxUa() {
  return getUrlParam('ua') == 'baidu';
}
// 是否为支付宝webview环境
function isAlipayH5() {
  var ua = navigator.userAgent.toLowerCase();
  return !isAlipayMiniUa() && /AlipayClient/gi.test(ua);
}
/**
 * 是否微信浏览器
 * @returns {boolean}
 */
function isWeixinBrowser() {
  var ua = navigator.userAgent.toLowerCase();
  if (!/MicroMessenger/gi.test(ua)) {
    return false;
  }
  if (isWxMiniProgram()) {
    //小程序
    return false;
  }
  return true;
}

function isCompanyApp() {
  let ua = navigator.userAgent || '';
  if (/huolala/i.test(ua) && /eclient|euser/i.test(ua)) {
    return true;
  }
  return false;
}

/**
 * 是否为货拉拉App或者是小拉app
 * @returns {boolean}
 */
function isHllApp() {
  if (
    isWxMiniProgram() ||
    isJdMiniProgram() ||
    isAlipayMiniUa() ||
    isBaiduBoxUa() ||
    isQuickAppUa() ||
    isBanjiaH5()
  ) {
    return false;
  }
  // if (/huolala/i.test(navigator.userAgent || '') && !isCompanyApp()) {
  if (/huolala/i.test(navigator.userAgent || '')) {
    return true;
  }

  return /(\?|&)_?token=/.test(location.href);
}

function isXlUserApp() {
  if (
    isWxMiniProgram() ||
    isAlipayMiniUa() ||
    isBaiduBoxUa() ||
    isQuickAppUa() ||
    isBanjiaH5()
  ) {
    return false;
  }
  let uaXl = getUrlParam('client_type') || getUrlParam('ua') || '';
  if (['xl_ios', 'xl_android'].includes(uaXl.toLowerCase())) {
    return true;
  }
  return false;
}
/**
 * 用户app版本号
 * @returns {boolean}
 */
function getUserAppVer() {
  return isHllApp() && getUrlParam('version')
    ? Number(getUrlParam('version'))
    : 0;
}

function isIOS() {
  return !!navigator.userAgent.match(/(iPad|iPhone|iPod|iOS|ios)/g);
}

function isMobile() {
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
}

function isXlDriverApp() {
  return !!navigator.userAgent.match(/com.xiaolachuxing.driveri?/g);
}
function lowXlVersionDriverApp() {
  const version = getUrlParam('revision');
  return isXlDriverApp() && version < 1020;
}
function lowXlVersionUserApp() {
  const version = getUrlParam('revision');
  console.log(version, 'version---->');
  return isXlUserNativeApp() && version < 1104;
}
// 小拉用户原生app
function isXlUserNativeApp() {
  return !!navigator.userAgent.match(/com.xiaolachuxing.useri?/g);
}
// 小拉用户app mPaas小程序版本
function isXlUserMpaasApp() {
  return !!navigator.userAgent.match(/mPaaSClient?/g);
}
function isXlApp() {
  return isXlUserNativeApp() || isXlDriverApp();
}
export {
  isWxMiniProgram,
  isWeixinBrowser,
  isHllApp,
  isLtlApp,
  isMoveMini,
  isJdMiniProgram,
  isLtlMiniProgram,
  isXlMiniProgram,
  isCompanyApp,
  isAlipayMiniUa,
  getUserAppVer,
  isMoveAlpayMini,
  isBaiduBoxUa,
  isQuickAppUa,
  isIOS,
  isMobile,
  isWxMiniProgramNew,
  isAlipayH5,
  isXiaoLaProgram,
  isXlUserApp,
  isXlApp,
  isXlAppByClientType,
  isXlMini,
  isXlDriverApp,
  isXlUserNativeApp,
  isXlUserMpaasApp,
  lowXlVersionDriverApp,
  lowXlVersionUserApp
};
